import { IconButton, useColorMode, useColorModeValue } from '@chakra-ui/react';
import { FiSun, FiMoon } from 'react-icons/fi';
import IconWrapper from './IconWrapper';

const ThemeToggle: React.FC = () => {
  const { colorMode, toggleColorMode } = useColorMode();
  const isDark = colorMode === 'dark';

  return (
    <IconButton
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      icon={<IconWrapper icon={isDark ? FiSun : FiMoon} size={20} />}
      variant="ghost"
      color={useColorModeValue('gray.600', 'gray.300')}
      _hover={{
        color: useColorModeValue('gray.800', 'white'),
        bg: useColorModeValue('gray.100', 'gray.700'),
      }}
      onClick={toggleColorMode}
      size="sm"
    />
  );
};

export default ThemeToggle;
